module.exports = __webpack_public_path__ + "img/bg-4.f96ed948.jpg";